import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { PreCheckOut } from "./components/PreCheckOut";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createHashRouter } from "react-router-dom"; // Import HashRouter
import { EventsView } from "./util/EventsView";
import { EventInfo } from "./components/EventInfo";
import { EventProvider } from "./util/EventProvider";
import { HelmetProvider } from "react-helmet-async";
import 'iframe-resizer/js/iframeResizer.contentWindow';

// Create a HashRouter instance
const router = createHashRouter([
  {
    path: "/",
    element: <EventsView />,
  },
  {
    path: "/event/:eventId",
    element: <PreCheckOut />,
  },
  {
    path: "/visit/:eventId",
    element: <EventInfo />,
  },
]);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <EventProvider>
        <RouterProvider router={router} />
      </EventProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
